// Reactの機能をインポートします。
import React from 'react';
// BuildItemコンポーネントをインポートします。これはこのファイルと同じディレクトリにある別のファイルです。
import BuildItem from './BuildItem';
import { useTranslation } from 'react-i18next';


// BuildAreaコンポーネントは、コマンドを表示および操作するためのUI部分を担当します。
// props経由でcommandList（コマンドの配列）とsetCommandList（その状態を更新する関数）を受け取ります。
const BuildArea = ({ commandList, setCommandList }) => {
    const { t } = useTranslation();

    // コマンドを新しい位置に移動する関数です。ドラッグアンドドロップのロジックを扱います。
    const moveCommand = (dragIndex, hoverIndex) => {
        // ドラッグされたコマンドを取得します。
        const dragCommand = commandList[dragIndex];
        // コマンドリストのコピーを新しい配列として作成します。
        const newCommands = [...commandList];
        // ドラッグしたコマンドをリストから削除します。
        newCommands.splice(dragIndex, 1);
        // コマンドを新しい位置に挿入します。
        newCommands.splice(hoverIndex, 0, dragCommand);
        // 更新されたコマンドリストで状態を設定します。
        setCommandList(newCommands);
    };

    // コマンドを削除する関数です。
    const removeCommand = (index) => {
        // コマンドリストのコピーを新しい配列として作成します。
        const newCommands = [...commandList];
        // 指定されたインデックスのコマンドを削除します。
        newCommands.splice(index, 1);
        // 更新されたコマンドリストで状態を設定します。
        setCommandList(newCommands);
    };

    // コマンドの値を更新する関数です。
    const onValueChange = (index, newValue) => {
        // コマンドリストのコピーを新しい配列として作成します。
        const newCommands = [...commandList];
        // 指定されたインデックスのコマンドの値を新しい値で更新します。
        newCommands[index] = {...newCommands[index], value: newValue};
        // 更新されたコマンドリストで状態を設定します。
        setCommandList(newCommands);
    };

    // 安全な処理のため、コマンドリストが null または undefined の場合でも空の配列を返すようにします。
    const safeCommands = commandList || [];

    // 実際のUIを構築する部分です。HTMLのテーブルを使用してコマンドをリスト表示します。
    
    return (
        
        <table>
            <caption>{t('build_area_title')}</caption>
            <tbody>
                {/* safeCommands配列をmap関数を使ってループし、各コマンドごとにBuildItemコンポーネントを描画します。 */}
                
                {safeCommands.map((command, index) => (
                    // BuildItemには、コマンド、インデックス、各種操作用の関数をpropsとして渡します。
                    <BuildItem
                        key={command.id}
                        command={command}
                        index={index}
                        moveCommand={moveCommand}
                        removeCommand={removeCommand}
                        onValueChange={onValueChange} // コマンドの値を更新するための関数をpropsとして渡します。
                        
                    />
                ))}
            </tbody>
        </table>
    );
};

// 他のファイルからBuildAreaコンポーネントをimportできるように、ここでエクスポートします。
export default BuildArea;
